import buildScreenHeaderItems from '@/components/buildScreenHeaderItems'
import useWebBackButton from '@/lib/hooks/useWebBackButton'
import CoversByFolder from '@/modules/covers/CoversByFolder'
import CoversByKeyword from '@/modules/covers/CoversByKeyword'
import { openCreateFormSheet } from '@/redux/slices/createFormSheetSlice'
import { fetchFolderThunk, folderSelectors } from '@/redux/slices/folderSlice'
import { useAppDispatch, useAppSelector } from '@/redux/store'
import { androidHeaderSearchBarThemeProps } from '@/theme'
import { useTheme } from '@react-navigation/native'
import { Stack, useLocalSearchParams } from 'expo-router'
import Head from 'expo-router/head'
import { debounce } from 'lodash-es'
import { useEffect, useMemo, useState } from 'react'
import { Platform } from 'react-native'

export default function FolderPage() {
  const theme = useTheme()
  const { folderToken } = useLocalSearchParams<{ folderToken: string }>()
  const dispatch = useAppDispatch()
  const headerLeftItems = useWebBackButton('/forms')

  const folderName = useAppSelector(state => folderSelectors.selectById(state, folderToken)?.name)

  const [searchKeyword, setSearchKeyword] = useState<string | undefined>(undefined)

  useEffect(() => {
    dispatch(fetchFolderThunk({ folderToken }))
  }, [dispatch, folderToken])

  const handlePress = () => {
    dispatch(openCreateFormSheet({ folderToken }))
  }

  const handleSearchDebounced = useMemo(() => debounce(setSearchKeyword, 500), [setSearchKeyword])

  return (
    <>
      {Platform.OS === 'web' && folderName && (
        <Head>
          <title>{folderName}</title>
        </Head>
      )}
      <Stack.Screen
        options={{
          title: folderName ?? '',
          ...buildScreenHeaderItems({
            left: headerLeftItems,
            right: [
              {
                type: 'button',
                label: '新建表单',
                variant: 'prominent',
                icon: {
                  name: 'plus',
                  type: 'sfSymbol',
                },
                onPress: handlePress,
              },
            ],
          }),
          headerSearchBarOptions: {
            placement: 'automatic',
            placeholder: '搜索表单',
            ...androidHeaderSearchBarThemeProps(theme),
            onChangeText: ({ nativeEvent }) => {
              handleSearchDebounced(nativeEvent.text)
            },
          },
        }}
      />

      {searchKeyword ? <CoversByKeyword keyword={searchKeyword} /> : <CoversByFolder folderToken={folderToken} />}
    </>
  )
}
